"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DATUM_DISPLAY () {
        return DATUM_DISPLAY;
    },
    get DatumToggleOrder () {
        return DatumToggleOrder;
    },
    get HORIZONTAL_DATUM () {
        return HORIZONTAL_DATUM;
    },
    get VDATUM_ELEVATION_DATUM () {
        return VDATUM_ELEVATION_DATUM;
    }
});
const _constants = require("../constants");
const VDATUM_ELEVATION_DATUM = {
    [_constants.ELEVATION_DATUM.NGVD_1929]: "NGVD29",
    [_constants.ELEVATION_DATUM.NAVD_1988]: "NAVD88"
};
const HORIZONTAL_DATUM = {
    [_constants.ELEVATION_DATUM.NGVD_1929]: "NAD27",
    [_constants.ELEVATION_DATUM.NAVD_1988]: "NAD83(2011)"
};
const DATUM_DISPLAY = {
    [_constants.ELEVATION_DATUM.NGVD_1929]: {
        short: "NGVD29",
        long: "NGVD 1929"
    },
    [_constants.ELEVATION_DATUM.NAVD_1988]: {
        short: "NAVD88",
        long: "NAVD 1988"
    },
    [_constants.ELEVATION_DATUM.PRVD02]: {
        short: "PRVD02 (MSL)",
        long: "PRVD02 (MSL)"
    },
    [_constants.ELEVATION_DATUM.LTD]: {
        short: "LTD",
        long: "LTD"
    },
    [_constants.ELEVATION_DATUM.OTHER]: {
        short: "Other",
        long: "Other"
    }
};
const DatumToggleOrder = {
    [_constants.ELEVATION_DATUM.NGVD_1929]: 0,
    [_constants.ELEVATION_DATUM.NAVD_1988]: 1,
    [_constants.ELEVATION_DATUM.PRVD02]: 2,
    [_constants.ELEVATION_DATUM.LTD]: 3,
    [_constants.ELEVATION_DATUM.OTHER]: 4
};

//# sourceMappingURL=data:application/json;base64,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